import { collection, query, where, onSnapshot, doc, setDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'studentBehaviors';

export const POSITIVE_CATEGORIES = [
  'Excellent Participation', 'Helpfulness', 'Leadership',
  'Notable Improvement', 'Good Conduct', 'Academic Excellence'
];

export const NEGATIVE_CATEGORIES = [
  'Classroom Disruption', 'Disrespect', 'Lateness', 'Fighting',
  'Dishonesty', 'Dress Code Violation', 'Other'
];

export const categoriesFor = (type) => (type === 'Positive' ? POSITIVE_CATEGORIES : NEGATIVE_CATEGORIES);

const newId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID().toUpperCase() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export const studentBehaviorService = {
  subscribeToBehaviors({ schoolId = null, studentIds = null }, callback) {
    let q = collection(db, COLLECTION);
    if (!schoolId && studentIds) {
      if (!studentIds.length) { callback([]); return () => {}; }
      q = query(q, where('studentId', 'in', studentIds.slice(0, 30)));
    }
    return onSnapshot(q, (snap) => {
      const list = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
      .filter(d => {
        if (!schoolId) return true;
        const ids = (Array.isArray(schoolId) ? schoolId : [schoolId]).map(v => String(v).toLowerCase());
        return ids.includes((d.schoolId || '').toLowerCase());
      });
      list.sort((a, b) => new Date(b.date) - new Date(a.date));
      callback(list);
    }, (err) => {
      console.error('Error loading behaviors:', err);
      callback([]);
    });
  },

  async addBehavior(data) {
    const id = newId();
    // iOS decodes dates with ISO8601DateFormatter (.withInternetDateTime) which
    // does NOT accept fractional seconds — strip ".SSS" so it parses on iOS.
    const now = new Date().toISOString().replace(/\.\d{3}Z$/, 'Z');
    const docData = {
      id,
      studentDocumentId: '',
      studentPhotoURL: '',
      note: '',
      date: now,
      createdAt: now,
      ...data
    };
    // iOS decodes classId/schoolId as UUID? — an empty string fails decode and
    // drops the whole document, so omit the field entirely when falsy.
    if (docData.classId) docData.classId = String(docData.classId);
    else delete docData.classId;
    if (docData.schoolId) docData.schoolId = String(docData.schoolId);
    else delete docData.schoolId;
    await setDoc(doc(db, COLLECTION, id), docData);
    return id;
  },

  updateBehavior(id, data) {
    return updateDoc(doc(db, COLLECTION, id), data);
  },

  deleteBehavior(id) {
    return deleteDoc(doc(db, COLLECTION, id));
  }
};
